import { RatgeberArticlePageAsChildofCategory, RatgeberCategoryPage } from "../../ratgeber/_types"
import { useState } from "react"
import styles from "./articleCard.module.scss"
import { Divider } from "@mui/material"
import Image from "next/image"
import StyledText from "../../typography/typography-component"
import skColors from "../../../styles/skColors"
import Link from "next/link"
import { useTypedRouter } from "../../data/routes"

const CategoryArticleCard = ({
  category,
  article,
  isFeatured = false,
}: {
  category: RatgeberCategoryPage
  article: RatgeberArticlePageAsChildofCategory
  isFeatured?: boolean
}) => {
  const [authorShown, setIsAuthorShown] = useState(true)
  const router = useTypedRouter()

  const goToArticle = () => router.push(`/ratgeber/${category.meta.slug}/${article.slug}`)

  return (
    <Link href={`/ratgeber/${category.meta.slug}/${article.slug}`}>
      <div className={styles.card}>
        <div className={styles.cardImage}>
          <Image
            className={styles.ratgeberArticleImage}
            // style={{
            //   maxWidth: "100%",
            //   height: "auto",
            // }}
            // width={article.banner_image.width}
            // height={article.banner_image.height}
            src={article.banner_image}
            alt={article.title}
            fill
            sizes="100vw"
            style={{
              objectFit: "cover",
            }}
          />
        </div>
        <div className={styles.cardTitle}>
          <StyledText variant={"h3"} color={skColors.darkgreen[600]}>
            {article.title}
          </StyledText>
        </div>
        <div className={styles.cardText}>
          <Divider className={styles.divider} />
          <StyledText className={styles.threeLineEllipse} variant={"pRegular"} color={skColors.darkgreen[600]}>
            {article.description}
          </StyledText>
        </div>
      </div>
    </Link>
  )
}

export default CategoryArticleCard